import {debounce, DebouncedFn, TargetFn} from '@/util/func';
import {useEffect, useMemo} from 'react';

export default function useDebounce<A, R>(fn: TargetFn<A, R>, timeout: number): DebouncedFn<A, R> {
	const [debounced, destructor] = useMemo(() => {
		return debounce(fn, timeout);
	}, [fn, timeout]);

	useEffect(() => {
		return destructor;
	}, [destructor]);

	return debounced;
}
